var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-row-container',{attrs:{"spacing":"16px"}},[_c('header4-prominent',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }